import { message, Space, Typography } from "antd";
import { getFullName, getPhoneNumber } from "../../utils/shared";
import { useRef } from "react";
import Select from "../generic/Select";

const { Text } = Typography;

/**
 * Common Avatar Component
 * @param {import('antd').SelectProps & {
 *   users?:        Array<{
 *     id:             string;
 *     first_name?:    string;
 *     last_name?:     string;
 *     email?:         string;
 *     mobile_number?: string;
 *     disabled?: Boolean;
 *   }>;
 *   mode?:         "single" | "multiple" | 'tags';
 *   maxTagCount?:  number | "responsive";
 *   allowClear?:   boolean;
 * }} props
 */

const MemberSelect = ({
  users = [],
  maxTagCount = "responsive",
  mode,
  value,
  onChange, 
  ...rest
}) => {
  const lastValuesRef = useRef([]);
  return (
    <Select
      {...rest}
      mode={mode}
      value={value}
      options={users.map((user) => {
        const number = getPhoneNumber(user);
        const name = getFullName(user);
        return {
          value: user.id,
          label: (
            <Space size={8} align="center">
              <span>{name}</span>
              <Text type="secondary" style={{ fontSize: 12 }}>
                {user.email} {number}
              </Text>
            </Space>
          ),
          disabled: user?.disabled,
          searchLabel: `${name} ${user.email} ${number}`,
        };
      })}
      //@ts-ignore
      maxTagCount={maxTagCount}
      showSearch={{
        filterOption: (input, option) =>
          option.searchLabel?.toLowerCase().includes(input.toLowerCase()),
      }}
      optionLabelProp="label"
      optionRender={(option) => option.label}
      onChange={(values, options) => {
        if (JSON.stringify(values) === JSON.stringify(lastValuesRef.current))
          return;

        lastValuesRef.current = values;

        if (mode === "tags") {
          const phoneRegex = /^\+[0-9]{1,4}-[0-9]{6,14}$/;

          const validValues = values.filter((val, index) => {
            if (options?.[index]?.value === val) return true;

            const isValid = phoneRegex.test(val);

            if (!isValid)
              message.error(
                `Invalid phone number: ${val}. Expected format: +91-XXXXXXXXXX`,
              );

            return isValid;
          });

          onChange(validValues);
          return;
        }

        onChange(values);
      }}
    />
  );
};

export default MemberSelect;
